import { Injectable } from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {LicensedAgent} from "../interface/licensed-agent";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {first, take} from "rxjs/operators";
import {FilterService} from "./filter.service";
import {ReceivablesPaymentImportRow} from "../interface/receivables-payment-import-row";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class LicensedAgentService {
  public readonly licensedAgentListSubject: ReplaySubject<CountedAndPaginated<LicensedAgent>>
    = new ReplaySubject<CountedAndPaginated<LicensedAgent>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
  ) { }

  public send(formData: object, uuid?: string): Observable<any> {
    if (uuid) {
      return this.httpClient.put(`/rest/crm/licensed-agent/${uuid}`, formData)
        .pipe(take(1)) as Observable<Uuid>;
    } else {
      return this.httpClient.post(`/rest/crm/licensed-agent`, formData)
        .pipe(
          take(1)
        );
    }
  }

  public loadList(page: number, pageSize: number, filters: object): void
  {
    this.httpClient.get(`/rest/crm/licensed-agent?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe({
        next: (result: CountedAndPaginated<LicensedAgent>) => {
          this.licensedAgentListSubject.next(result);
        }, error: (error: HttpErrorResponse) => {
          this.licensedAgentListSubject.error(error);
        }
      });
  }


  public statusUpdate(id: string, status: number): Observable<any> {
   return this.httpClient.post(`/rest/crm/licensed-agent/status-update/${id}`, {
     status: status,
   })
     .pipe(take(1));
  }

  public get(uuid: string): Observable<LicensedAgent> {
    return this.httpClient.get(`/rest/crm/licensed-agent/${uuid}`)
      .pipe(first()) as Observable<LicensedAgent>;
  }

  public downloadReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/licensed-agent/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }
}
